import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TempStorage from "./Storage.jsx";

const ProtectedRoute = ({ children, checks}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      setIsAuthenticated(true);
      try {
        checks.forEach(e => {
          if (TempStorage.exists(e) === false && document.cookie.indexOf(e) === -1) {
            setIsAuthenticated(false);
            TempStorage.set('authAlert', 'Devi effettuare il login per accedere a questa pagina');
            navigate("/");
          }
        });
      } catch (error) {
        setIsAuthenticated(false);
        TempStorage.set('authAlert', 'Devi effettuare il login per accedere a questa pagina');
        navigate("/");
      }
    };
    checkAuth();
  }, [navigate]);
  return isAuthenticated ? children : null;
};

export default ProtectedRoute;
